import { render, staticRenderFns } from "./ApplicationScoreNegativeNote.vue?vue&type=template&id=7835f8fa&lang=pug&"
import script from "./ApplicationScoreNegativeNote.vue?vue&type=script&lang=js&"
export * from "./ApplicationScoreNegativeNote.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationScoreNegativeNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ApplicationScoreNegativeNote.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports